var _rect, _rect2, _ellipse, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeedPacket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 339,
    viewBox: "0 0 269 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 339,
    rx: 10,
    fill: "#F8B551"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 62,
    fill: "#A67731"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 193,
    rx: 92,
    ry: 69,
    fill: "#FFF3E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.167 142.583C146.917 142.583 148.667 142.583 150.125 142.875C150.708 149.583 150.708 163 142.833 172.333C137 179.625 127.083 183.417 113.667 183.417H109.875C109.292 170 111.917 159.5 118.042 152.792C125.333 144.333 137 142.583 145.167 142.583ZM145.167 136.75C129.125 136.75 99.6667 142.875 104.333 188.667C107.542 188.958 110.75 189.25 113.667 189.25C165.875 189.25 155.375 137.625 155.375 137.625C155.375 137.625 151.292 136.75 145.167 136.75ZM144.583 148.417C115.417 148.417 115.417 177.583 115.417 177.583C127.083 154.25 144.583 148.417 144.583 148.417Z",
    fill: "#937356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.167 177.583C189.917 177.583 191.667 177.583 193.125 177.875C193.708 184.583 193.708 198 185.833 207.333C180 214.625 170.083 218.417 156.667 218.417H152.875C152.292 205 154.917 194.5 161.042 187.792C168.333 179.333 180 177.583 188.167 177.583ZM188.167 171.75C172.125 171.75 142.667 177.875 147.333 223.667C150.542 223.958 153.75 224.25 156.667 224.25C208.875 224.25 198.375 172.625 198.375 172.625C198.375 172.625 194.292 171.75 188.167 171.75ZM187.583 183.417C158.417 183.417 158.417 212.583 158.417 212.583C170.083 189.25 187.583 183.417 187.583 183.417Z",
    fill: "#937356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.167 199.583C128.917 199.583 130.667 199.583 132.125 199.875C132.708 206.583 132.708 220 124.833 229.333C119 236.625 109.083 240.417 95.6667 240.417H91.875C91.2917 227 93.9167 216.5 100.042 209.792C107.333 201.333 119 199.583 127.167 199.583ZM127.167 193.75C111.125 193.75 81.6667 199.875 86.3333 245.667C89.5417 245.958 92.75 246.25 95.6667 246.25C147.875 246.25 137.375 194.625 137.375 194.625C137.375 194.625 133.292 193.75 127.167 193.75ZM126.583 205.417C97.4167 205.417 97.4167 234.583 97.4167 234.583C109.083 211.25 126.583 205.417 126.583 205.417Z",
    fill: "#937356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedPacket);
export default __webpack_public_path__ + "static/media/seed-packet.7b31beca7134ee745bf9f9ba87bcc271.svg";
export { ForwardRef as ReactComponent };